export default __webpack_public_path__ + "static/media/comingsoon_grey.b3e33c1e.svg";